import { render, staticRenderFns } from "./DrawRecord.vue?vue&type=template&id=befeccec&scoped=true&"
import script from "./DrawRecord.vue?vue&type=script&lang=js&"
export * from "./DrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./DrawRecord.vue?vue&type=style&index=0&id=befeccec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befeccec",
  null
  
)

export default component.exports